<!-- Breadcrumb -->

<div class="page-breadcrumb p-t-20 p-b-20 p-l-30 p-r-30">
	<div fxLayout="row wrap">
        <div fxFlex.gt-sm="60" fxFlex.gt-xs="60" fxFlex="100" fox class="align-self-center" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <mat-icon *ngIf="videos?.length > 0" [@cardAnimator]="animationState" matTooltip="View Instructional Video" (click)="openVideoModal()" color="primary" class="video-icon link">ondemand_video</mat-icon>
            <h4 class="page-title text-themecolor m-0">{{pageInfo?.title}}</h4>
		</div>
		<div fxFlex.gt-sm="40" fxFlex.gt-xs="40" fxFlex="100" class="align-self-center">
            <div class="breadcrumb d-flex align-items-center float-right float-sm-left">
                <ul class="list-style-none d-flex align-items-center">
                    <ng-template ngFor let-url [ngForOf]="pageInfo?.urls" let-last="last">
                        <li class="breadcrumb-item" *ngIf="!last" (click)="navigateByUrl(url.url)">
                            <a *ngIf="url.url" [routerLink]="url.url">{{url.title}}</a>
                            <ng-container *ngIf="!url.url">{{url.title}}</ng-container>
                        </li>
                        <li class="breadcrumb-item active" *ngIf="last">{{url.title}}</li>
                    </ng-template>
                </ul>
            </div>
        </div>
    </div>
</div>